export const calendarColors = (color?: string | null): string => {
    const calendarColors = [
        {value: 'red', hex: '#dc2626'},
        {value: 'gray', hex: '#475569'},
        {value: 'orange', hex: '#ea580c'},
        {value: 'yellow', hex: '#ca8a04'},
        {value: 'green', hex: '#16a34a'},
        {value: 'teal', hex: '#0d9488'},
        {value: 'purple', hex: '#9333ea'},
        {value: 'pink', hex: '#db2777'},
        {value: 'blue', hex: '#2563eb'},
        {value: 'indigo', hex: '#4f46e5'},
    ];
    const colorObj = calendarColors.find((c) => c.value === color);
    return colorObj ? colorObj.hex : calendarColors[0].hex;
};


export const calendarColorsList = (): any => {
    return [
        {value: 'red', hex: '#dc2626'},
        {value: 'gray', hex: '#475569'},
        {value: 'orange', hex: '#ea580c'},
        {value: 'yellow', hex: '#ca8a04'},
        {value: 'green', hex: '#16a34a'},
        {value: 'teal', hex: '#0d9488'},
        {value: 'purple', hex: '#9333ea'},
        {value: 'pink', hex: '#db2777'},
        {value: 'blue', hex: '#2563eb'},
        {value: 'indigo', hex: '#4f46e5'},
    ];
};




